import {useGetContainerStatusInsights, UseGetContainerStatusInsightsResult} from "./useGetContainerStatusInsights";
import {useGetInsights, UseGetInsightsProps, UseGetInsightsResult} from "./useGetInsights";

export type UseGetRecentInsightsProps = UseGetInsightsProps

export type UseGetRecentInsightsResult = UseGetInsightsResult & {
  containerStatus: UseGetContainerStatusInsightsResult
}

export const useGetRecentInsights = (props: UseGetInsightsProps): UseGetRecentInsightsResult => {
  const {category, ...rest} = props

  const insights = useGetInsights({
    ...rest,
    category: category,
  })

  const _containerStatusResults = useGetContainerStatusInsights({
    category: category,
  })

  return {
    ...insights,
    containerStatus: _containerStatusResults,
  }
}
